import { render } from "./artistFeedComponent.vue?vue&type=template&id=487dd2cb&scoped=true"
import script from "./artistFeedComponent.vue?vue&type=script&lang=js"
export * from "./artistFeedComponent.vue?vue&type=script&lang=js"

import "./artistFeedComponent.vue?vue&type=style&index=0&id=487dd2cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487dd2cb"]])

export default __exports__